<script>
// MyComponent.vue
// import ordersCSV from '../orders.csv'
// import productsCSV from '../products.csv'
import Papa from 'papaparse'
import VueJsonToCsv from 'vue-json-to-csv'
import { onMounted, onUnmounted, ref } from 'vue'

export default {
  // components: {
  //   VueJsonToCsv,
  // },
  data() {
    return {
      userPass: '',
      showPopUp: true,
    }
  },
  methods: {
    enterPassword(){
      if(this.userPass.toLowerCase() === 'banana'){//I know
        this.showPopUp = false
        console.log('correct')
      }
    }
  }
}
</script>

<template>
  <div v-if="this.showPopUp" class="password">
    <div class="container">
      <h3>Enter Password To Access</h3>
      <input v-model="userPass" @keyup.enter="enterPassword" placeholder="Enter password" />
    </div>
  </div>
  <header>
    <nav>
      <router-link to="/OHU">OHU</router-link> |
      <router-link to="/returns">Returns</router-link> |
      <router-link to="/replen">Replen</router-link> |
      <router-link to="/orders">Orders</router-link> |
      <router-link to="/bxz">Boxes</router-link> |
      <!-- <router-link to="/sph">SPH</router-link> | -->
      <!-- <router-link to="/ecom">Ecom</router-link> | -->
      <router-link to="/barcodes">Barcodes</router-link>


    <!-- <div class="uploads">
      Product
      <input v-if="!productsCSV.length" id="choose-file" type="file" @change="handleFileUploadProd" accept=".csv" placeholder="Enter Product CSV" /> <br>
      Orders
      <input v-if="!ordersCSV.length" id="choose-file" type="file" @change="handleFileUploadOrd" accept=".csv" placeholder="Enter Order CSV" /> <br>
    </div> -->



    </nav>

    <router-view/>

  </header>

</template>

<style lang="scss">
html {
  background-color: #2f2f3c;
  color: #bfbfda;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    // color: #2c3e50;
    color: white;
    margin: 0.25em;
    text-decoration: none;
    &:hover {
      color: violet;
    }

    &.router-link-exact-active {
      color: violet;
    }
  }
  .uploads{
    margin-top:1em;
  }
}
input {
  padding: 0.5em;
  border: 4px solid black;
  margin-bottom: 1em;
}

.password{
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: black;
  top:0;
  left:0;

  .container{
    margin-top: 15%;
  }
}
</style>
